import { render, staticRenderFns } from "./EstablishmentTransferStatusBadge.vue?vue&type=template&id=ba4533a2"
import script from "./EstablishmentTransferStatusBadge.vue?vue&type=script&lang=js"
export * from "./EstablishmentTransferStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports